import React from 'react';
import { useTranslation } from 'react-i18next'; // 1. Import hook
import {
  Container,
  Box,
  Typography,
  Button,
  Stepper,
  Step,
  StepLabel,
  CircularProgress,
} from '@mui/material';
import { IconArrowLeft, IconArrowRight } from '@tabler/icons-react';

const WizardLayout = ({
  step,
  totalSteps,
  title,
  stepTitles,
  children,
  onNext,
  onBack,
  isFirstStep,
  isLastStep,
  isSubmitting,
  submitText = 'Submit',
}) => {
  const { t } = useTranslation(); // 2. Initialize translation function

  return (
    <Box sx={{ py: 10, backgroundColor: 'grey.50', minHeight: '80vh' }}>
      <Container maxWidth="md">
        <Typography variant="h3" component="h1" align="center" gutterBottom fontWeight="bold">
          {title}
        </Typography>

        <Stepper activeStep={step - 1} alternativeLabel sx={{ my: 5 }}>
          {stepTitles.map((label) => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>

        <Box>{children}</Box>

        <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 6 }}>
          <Button
            variant="outlined"
            onClick={onBack}
            disabled={isFirstStep}
            startIcon={<IconArrowLeft />}
            sx={{ visibility: isFirstStep ? 'hidden' : 'visible' }}
          >
            {t('wizard_back_button')} {/* 3. Use translation */}
          </Button>

          <Button
            variant="contained"
            onClick={onNext}
            disabled={isSubmitting}
            endIcon={!isSubmitting && <IconArrowRight />}
            sx={{
              backgroundColor: '#D4A259',
              '&:hover': { backgroundColor: '#b88b4a' },
            }}
          >
            {isSubmitting ? (
              <CircularProgress size={24} color="inherit" />
            ) : isLastStep ? (
              submitText
            ) : (
              t('wizard_next_button') // 3. Use translation
            )}
          </Button>
        </Box>
      </Container>
    </Box>
  );
};

export default WizardLayout;